import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const CAIRO_OFFSET_MINUTES = 180;

const hasExplicitZone = (value) =>
  /[zZ]$/.test(value) || /[+-]\d{2}:\d{2}$/.test(value) || /[+-]\d{4}$/.test(value);

export const parseCairoDate = (value) => {
  if (value == null || value === "") return null;
  const raw = String(value).trim();
  if (!raw || raw.startsWith("0000")) return null;

  let naive = raw.replace(" ", "T").replace(/\.\d+$/, "");
  if (/^\d{4}-\d{2}-\d{2}$/.test(naive)) {
    naive = `${naive}T00:00:00`;
  } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(naive)) {
    naive = `${naive}:00`;
  }

  const parsed = hasExplicitZone(raw) ? dayjs(raw) : dayjs(`${naive}+03:00`);

  if (!parsed.isValid() || parsed.year() < 2000) return null;
  return parsed;
};

export const toDatetimeLocalValue = (value) => {
  const parsed = parseCairoDate(value);
  if (!parsed) return "";
  return parsed.utcOffset(CAIRO_OFFSET_MINUTES).format("YYYY-MM-DDTHH:mm");
};

export const toServerDateTime = (value) => {
  if (value == null || value === "") return "";
  const normalized = String(value).trim().replace("T", " ").replace(/\.\d+$/, "");
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(normalized)) {
    return `${normalized}:00`;
  }
  return normalized;
};

export const formatDuration = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const clock = [hours, minutes, seconds]
    .map((part) => String(part).padStart(2, "0"))
    .join(":");
  return days > 0 ? `${days}d ${clock}` : clock;
};

export const getExamSchedule = (exam, now = dayjs()) => {
  const start = parseCairoDate(exam?.start_date);
  const end = parseCairoDate(exam?.end_date);
  const current = dayjs(now);
  const beforeStart = Boolean(start && current.isBefore(start));
  const afterEnd = Boolean(end && !current.isBefore(end));

  return {
    hasStart: Boolean(start),
    hasEnd: Boolean(end),
    beforeStart,
    afterEnd,
    canEnter: !beforeStart && !afterEnd,
    startsIn: beforeStart ? formatDuration(start.diff(current)) : null,
    closesIn: end && !afterEnd ? formatDuration(end.diff(current)) : null,
  };
};
